import { render, staticRenderFns } from "./lawsuit-follow-allot.vue?vue&type=template&id=d6588bfc&scoped=true"
import script from "./lawsuit-follow-allot.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow-allot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6588bfc",
  null
  
)

export default component.exports